var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',_vm._g(_vm._b({ref:"modal",scopedSlots:_vm._u([{key:"modal-header",fn:function(){return [_vm._t("modal-header")]},proxy:true},{key:"modal-footer",fn:function(){return [_vm._t("modal-footer")]},proxy:true}],null,true)},'b-modal',{ ..._vm.$props, ..._vm.$attrs },false),_vm.$listeners),[_vm._v(" "),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }